import { mutator } from 'satcheljs';
import getStore from '../store/store';
import { discardActionConfirmationsOption } from '../actions/internalActions';
import { getUserConfiguration } from 'owa-session-store';

mutator(discardActionConfirmationsOption, () => {
    getStore().actionConfirmationsEnabled = getUserConfiguration().UserOptions.ShowNotificationBar;
});
